import React from "react";
import { router, Stack, useLocalSearchParams } from "expo-router";

import { CopySaveForm } from "~/components/CopySave/Form";
import { HeaderX } from "~/components/HeaderElements";
import { decodeSaveIDsFromURL } from "~/app/(app)/(authenticated)/[account]/(space)/[space]/saves";

function CopyToIndexPage() {
  const params = useLocalSearchParams<{ sourceSpaceId: string; ids: string }>();

  const saveIDs = decodeSaveIDsFromURL(params.ids!);

  return (
    <>
      <Stack.Screen
        options={{
          headerTitle: `Copy ${saveIDs.length} saves`,
          headerRight: () => <HeaderX onPress={router.back} />,
        }}
      />
      <CopySaveForm
        onSuccess={() => {
          router.back();
        }}
        saveId={saveIDs.at(0)!}
        srcSpaceId={params.sourceSpaceId!}
      />
    </>
  );
}

export default CopyToIndexPage;
